/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ScrollIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="scroll"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M15.891 6L15.891 18" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.891 6A2.242 2.242 0 1 1 19.391 8" data-tinysvg-shape="arc" data-tinysvg-arc="18.129 6.147 2.242 2.242 183.756 415.734 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.891 18A2.242 2.242 0 1 1 12.391 16" data-tinysvg-shape="arc" data-tinysvg-arc="13.654 17.853 2.242 2.242 3.756 235.734 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.391 16L4.488 16" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.649 20.096L5.764 20.096" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.764 20.096A2.242 2.242 0 0 1 4.488 16.009" data-tinysvg-shape="arc" data-tinysvg-arc="5.764 17.853 2.242 2.242 90 235.314 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.266 3.909L8.891 3.909C7.787 3.909 6.891 4.804 6.891 5.909L6.891 15.909" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.891 9L9.891 9" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 13L9.891 13" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
